// extracted by mini-css-extract-plugin
export var darkBlueHoverButton = "buttons-module--dark-blue-hover-button--73111";
export var darkThemeGhostButton = "buttons-module--dark-theme-ghost-button--c6786";
export var defaultButton = "buttons-module--default-button--2ca9d";
export var secondaryButton = "buttons-module--secondary-button--24ea9";